import axiosInstance from "@/api/axiosInstance";
import { FavoritesKeyResponse } from "./types";

export const getFavoritesKey = async (
  context?: string,
): Promise<FavoritesKeyResponse> => {
  const params = context ? { context } : undefined;
  const response = await axiosInstance.get<FavoritesKeyResponse>(
    "/api/search/favorites-key",
    { params },
  );
  return response.data;
};
